import React from "react";
import { useTheme } from "@mui/material";
import AddIcon from "src/icons/AddIcon";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const FileUploadButton = ({
  isReadOnly,
  testId = "file-upload-button",
  onClick
}) => {
  const theme = useTheme();

  return (
    <HyroButton
      variant={BUTTON_VARIANTS.OUTLINED}
      color={BUTTON_COLORS.PRIMARY}
      onClick={onClick}
      disabled={isReadOnly}
      startIcon={<AddIcon color={isReadOnly ? theme.palette.system[400] : theme.palette.primary[500]} />}
      data-testid={testId}
    >
      New
    </HyroButton>
  );
};

export default FileUploadButton;
